import { render, staticRenderFns } from "./RcvE.vue?vue&type=template&id=56336f41"
import script from "./RcvE.vue?vue&type=script&lang=js"
export * from "./RcvE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports